import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Header from "./Header";
import Select from "react-select";
import Footer from "./Footer";

function AddComplain() {
  const navigate = useNavigate();
  const server_url = localStorage.getItem("server_url");
  const dealer_id = localStorage.getItem("dealer_id");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const [show, setShow] = useState(true);
  const [products, setProducts] = useState([]);
  const [selectedOrderd, setSelectedOrderd] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [complainProduct, setComplainProduct] = useState(null);
  const [quantity, setQuantity] = useState("");
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [image, setImage] = useState(null);
  const [video, setVideo] = useState(null);

  useEffect(() => {
    getOrders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (selectedOrderd) {
      getOrderDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrderd]);

  const getOrders = async () => {
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      formData.append("dealer_id", dealer_id);
      formData.append("type", "1");
      const res = await axios.post(`${server_url}order_list.php`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res.data.status === "1" && res.data.result.length > 0) {
        setProducts(res.data.result);
        setSelectedOrderd({
          value: res.data.result[0].order_id,
          label: res.data.result[0].order_title,
        });
      } else {
        toast.warning(res.data.error);
      }
    } catch (e) {
      toast.error("Please Try After Some Time.");
    }
  };

  const getOrderDetails = async () => {
    if (!selectedOrderd?.value) return toast.warning("Please select an order.");

    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      formData.append("dealer_id", dealer_id);
      formData.append("order_id", selectedOrderd.value);

      const res = await axios.post(`${server_url}order_details.php`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res.data.status === "1") {
        setSelectedProduct(res.data.result);
        // Clear selected product when order changes
        setComplainProduct(null);
        setQuantity("");
      } else {
        setSelectedProduct([]);
        setComplainProduct(null);
        setQuantity("");
        toast.warning("No products found for this order.");
      }
    } catch (e) {
      toast.error("Please Try After Some Time.");
    }
  };

  const handleOrderChange = (selectedOption) => {
    setSelectedOrderd(selectedOption);
    // Clear product selection and quantity when order changes
    setComplainProduct(null);
    setQuantity("");
  };

  const AddComplain = async () => {
    if (!dealer_id) {
      navigate("/Logout");
    }
    if (!selectedOrderd?.value) return toast.warning("Please select an order.");
    if (!complainProduct?.value)
      return toast.warning("Please select a product.");
    if (!quantity) return toast.warning("Please enter quantity.");
    if (!message) return toast.warning("Please enter message.");
    if (!title) return toast.warning("Please enter title.");

    const formData = new FormData();
    formData.append("company_id", "2");
    formData.append("dealer_id", dealer_id);
    formData.append("order_id", selectedOrderd.value);
    formData.append("order_details_id", complainProduct.value);
    formData.append("complain_issued_quantity", quantity);
    formData.append("complain_nature_of_issue", title);
    formData.append("complain_dealer_review", message);
    if (image) formData.append("complain_issue_image", image);
    if (video) formData.append("complain_issue_video", video);

    try {
      const response = await axios.post(
        `${server_url}add_complain.php`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (response.data.status === "1") {
        navigate("/Complain");
      } else {
        setShow(true);
        toast.warning(response.data.error || "Please try again later.");
      }
    } catch (error) {
      setShow(true);
      toast.error("Failed to add product. Please try again.");
    }
    setShow(true);
  };

  const options = useMemo(
    () =>
      products.map((product) => ({
        value: product.order_id,
        label: product.order_title,
      })),
    [products]
  );

  const options2 = useMemo(
    () =>
      (selectedProduct || []).map((product) => ({
        value: product.order_details_id,
        label: `${product.product_name} - QTY: ${product.order_details_qty}`,
        productDetails: product,
      })),
    [selectedProduct]
  );

  // Custom styles for react-select
  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      backgroundColor: "#ffffff",
      borderColor: state.isFocused ? "#db4437" : "#e5e5e5",
      color: "#000000",
      boxShadow: state.isFocused ? "0 0 0 3px rgba(219, 68, 55, 0.1)" : "none",
      "&:hover": {
        borderColor: state.isFocused ? "#db4437" : "#cccccc",
      },
      minHeight: "52px",
      borderRadius: "12px",
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: "#ffffff",
      border: "1px solid #e5e5e5",
      zIndex: 9999,
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? "#f8f9fa" : "#ffffff",
      color: "#000000",
      "&:active": {
        backgroundColor: "#f8f9fa",
      },
    }),
    singleValue: (base) => ({
      ...base,
      color: "#000000",
    }),
    input: (base) => ({
      ...base,
      color: "#000000",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#999999",
    }),
  };

  return (
    <div className="page-wrapper">
      <div className="sticky-header">
        <Header />
      </div>

      <div className="add-complain-content">
        <div className="complain-container">
          <div className="complain-card">
            <div className="complain-card-header">
              <h1>Add New Complaint</h1>
            </div>

            <div className="complain-form-container">
              <div className="complain-form-grid">
                {/* Order Selection */}
                <div className="input-group full-width">
                  <label>Select Order</label>
                  <Select
                    required
                    options={options}
                    value={selectedOrderd}
                    onChange={handleOrderChange}
                    placeholder="Select an Order"
                    styles={customSelectStyles}
                  />
                </div>

                {/* Product Selection */}
                <div className="input-group full-width">
                  <label>Select Product</label>
                  <Select
                    required
                    options={options2}
                    value={complainProduct}
                    onChange={(selectedOption) =>
                      setComplainProduct(selectedOption || null)
                    }
                    placeholder="Select a Product"
                    styles={customSelectStyles}
                  />
                </div>

                {/* Quantity Input */}
                <div className="input-group">
                  <label>Issue Quantity</label>
                  <input
                    required
                    type="number"
                    className="form-input"
                    placeholder={
                      complainProduct?.productDetails?.order_details_qty
                        ? `Max: ${complainProduct.productDetails.order_details_qty}`
                        : "Enter quantity"
                    }
                    value={quantity}
                    onChange={(e) => {
                      if (!complainProduct) return;
                      const enteredQty = parseInt(e.target.value, 10);
                      const maxQty =
                        complainProduct?.productDetails?.order_details_qty || 1;

                      if (enteredQty > maxQty) {
                        toast.warning(
                          `Issued quantity cannot be greater than supplied quantity.`
                        );
                        setQuantity(maxQty);
                      } else {
                        setQuantity(enteredQty);
                      }
                    }}
                    min="1"
                    max={
                      complainProduct?.productDetails?.order_details_qty || ""
                    }
                    disabled={!complainProduct}
                    style={{ borderRadius: "12px" }}
                  />
                </div>

                {/* Title Input */}
                <div className="input-group">
                  <label>Complaint Title</label>
                  <input
                    required
                    type="text"
                    onChange={(e) => setTitle(e.target.value)}
                    className="form-input"
                    placeholder="Enter complaint title"
                    value={title}
                    style={{ borderRadius: "12px" }}
                  />
                </div>

                {/* Message Textarea */}
                <div className="input-group full-width">
                  <label>Detailed Message</label>
                  <textarea
                    required
                    placeholder="Describe your complaint in detail"
                    onChange={(e) => setMessage(e.target.value)}
                    className="form-textarea"
                    rows="4"
                    value={message}
                    style={{ borderRadius: "12px" }}
                  />
                </div>

                {/* File Uploads */}
                <div className="input-group">
                  <label>Upload Image</label>
                  <div className="file-upload">
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => setImage(e.target.files[0])}
                      className="file-input"
                      style={{ borderRadius: "12px" }}
                    />
                    <div className="file-hint">PNG, JPG, JPEG (Max 5MB)</div>
                  </div>
                </div>

                <div className="input-group ">
                  <label>Upload Video</label>
                  <div className="file-upload">
                    <input
                      type="file"
                      accept="video/*"
                      onChange={(e) => setVideo(e.target.files[0])}
                      className="file-input"
                      style={{ borderRadius: "12px" }}
                    />
                    <div className="file-hint">MP4, MOV (Max 20MB)</div>
                  </div>
                </div>
              </div>

              {/* Submit Button */}
              <div className="button-container">
                {!show ? (
                  <div className="loading-state">
                    <div className="spinner"></div>
                    <p>Submitting your complaint...</p>
                  </div>
                ) : (
                  <button
                    type="button"
                    onClick={() => {
                      setShow(false);
                      AddComplain();
                    }}
                    className="submit-button"
                  >
                    Submit Complaint
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      <style jsx>{`
        .css-1xc3v61-indicatorContainer {
          background: #21252a00 !important;
          border: 0px solid #fff !important;
        }

        .page-wrapper {
          min-height: 100vh;
          background: #ffffff;
          display: flex;
          flex-direction: column;
        }

        .sticky-header {
          position: sticky;
          top: 0;
          z-index: 1000;
          width: 100%;
        }

        .add-complain-content {
          flex: 1;
          padding: 20px 15px;
          min-height: calc(100vh - 80px);
          margin-bottom: ${isMobile ? "70px" : "0"};
        }

        .complain-container {
          max-width: 900px;
          margin: 0 auto;
          width: 100%;
        }

        .complain-card {
          background: #ffffff;
          border-radius: 16px;
          box-shadow: 0 8px 40px rgba(0, 0, 0, 0.1);
          border: 1px solid #e5e5e5;
          overflow: hidden;
        }

        .complain-card-header {
          padding: 30px 25px 20px;
          border-bottom: 1px solid #e5e5e5;
          background: #f8f9fa;
        }

        .complain-card-header h1 {
          color: #000000;
          font-size: 24px;
          font-weight: 600;
          margin: 0 0 8px 0;
          text-align: center;
        }

        .complain-card-header p {
          color: #666666;
          font-size: 14px;
          margin: 0;
          line-height: 1.5;
          text-align: center;
        }

        .complain-form-container {
          padding: 25px;
        }

        .complain-form-grid {
          display: flex;
          flex-direction: column;
          gap: 20px;
          margin-bottom: 30px;
        }

        .input-group {
          display: flex;
          flex-direction: column;
        }

        .input-group.full-width {
          width: 100%;
        }

        .input-group label {
          color: #000000;
          font-weight: 600;
          margin-bottom: 10px;
          font-size: 14px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .form-input,
        .form-textarea,
        .file-input {
          background: #ffffff;
          border: 1px solid #e5e5e5;
          border-radius: 10px;
          padding: 14px 16px;
          color: #000000;
          font-size: 15px;
          transition: all 0.3s ease;
          font-family: inherit;
          width: 100%;
          box-sizing: border-box;
        }

        .form-input:focus,
        .form-textarea:focus {
          outline: none;
          border-color: #db4437;
          box-shadow: 0 0 0 3px rgba(219, 68, 55, 0.1);
        }

        .form-input:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          background: #f8f9fa;
        }

        .form-textarea {
          resize: vertical;
          min-height: 120px;
        }

        .file-upload {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .file-input {
          cursor: pointer;
          padding: 12px;
        }

        .file-input::-webkit-file-upload-button {
          background: #000000;
          border: none;
          color: #ffffff;
          padding: 8px 16px;
          border-radius: 6px;
          cursor: pointer;
          margin-right: 12px;
          font-weight: 500;
          transition: background 0.3s ease;
        }

        .file-input::-webkit-file-upload-button:hover {
          background: #333333;
        }

        .file-hint {
          color: #666666;
          font-size: 12px;
          font-style: italic;
        }

        .button-container {
          width: 100%;
          text-align: center;
          padding-top: 20px;
          border-top: 1px solid #e5e5e5;
        }

        .submit-button {
          background: #000000;
          color: white;
          border: none;
          padding: 16px 40px;
          border-radius: 10px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          width: 100%;
          max-width: 300px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .submit-button:hover {
          background: #db4437;
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(219, 68, 55, 0.2);
        }

        .submit-button:active {
          transform: translateY(0);
        }

        .loading-state {
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 15px;
          color: #000000;
        }

        .spinner {
          width: 40px;
          height: 40px;
          border: 4px solid #f0f0f0;
          border-left: 4px solid #db4437;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }

        /* Desktop Styles */
        @media (min-width: 768px) {
          .add-complain-content {
            padding: 30px 20px;
          }

          .complain-card-header {
            padding: 40px 50px 30px;
          }

          .complain-card-header h1 {
            font-size: 32px;
            text-align: left;
          }

          .complain-card-header p {
            font-size: 16px;
            text-align: left;
          }

          .complain-form-container {
            padding: 50px;
          }

          .complain-form-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 30px;
            margin-bottom: 40px;
          }

          .input-group.full-width {
            grid-column: 1 / -1;
          }

          .submit-button {
            width: auto;
            min-width: 220px;
            padding: 16px 50px;
          }
        }

        /* Large Desktop Styles */
        @media (min-width: 1024px) {
          .complain-container {
            max-width: 900px;
          }
        }

        /* Mobile Optimizations */
        @media (max-width: 767px) {
          .complain-card {
            margin-top: 70px;
            border-radius: 12px;
          }

          .complain-card-header {
            padding: 25px 20px 15px;
          }

          .complain-form-container {
            padding: 20px;
          }

          .complain-form-grid {
            gap: 15px;
            margin-bottom: 25px;
          }

          .form-input,
          .form-textarea,
          .file-input {
            padding: 12px 14px;
            font-size: 14px;
          }

          .submit-button {
            padding: 14px 30px;
            font-size: 15px;
          }

          /* Touch optimizations for mobile */
          @media (hover: none) and (pointer: coarse) {
            .submit-button:hover {
              transform: none;
            }
          }
        }

        /* Very small screens */
        @media (max-width: 360px) {
          .add-complain-content {
            padding: 15px 10px;
          }

          .complain-card-header {
            padding: 20px 15px 12px;
          }

          .complain-card-header h1 {
            font-size: 20px;
          }

          .complain-form-container {
            padding: 15px;
          }

          .complain-form-grid {
            gap: 12px;
          }
        }
      `}</style>
    </div>
  );
}

export default AddComplain;